module.exports = __webpack_public_path__ + "a6d0b4eba0eda67f991d69c754cce065.png";